// Changes invalidate views; the API remains the source of record state.
export const RECORDS_CHANGED = "rpo:records-changed";
const STORAGE_KEY = "rpo:records-changed";
let pending = false;
let installed = false;
function refreshViews() {
  window.dispatchEvent(new Event(RECORDS_CHANGED));
  window.dispatchEvent(new Event("rpo:activities-refresh"));
}
export function recordsChanged() {
  if (pending) return;
  pending = true;
  // Coalesce writes in the same turn and let the caller finish applying its response.
  window.setTimeout(() => {
    pending = false;
    refreshViews();
    try { localStorage.setItem(STORAGE_KEY, `${Date.now()}:${Math.random()}`); } catch {}
  }, 0);
}
export function installRecordChangeListeners() {
  if (installed) return;
  installed = true;
  window.addEventListener("storage", event => {
    if (event.key === STORAGE_KEY && event.newValue) refreshViews();
  });
  window.addEventListener("focus", refreshViews);
}
